import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'

export default class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|联系我们'
  }
  render() {
    return (
      <div style={{ background: '#f6f6f6' }}>
        <Header></Header>
        <div className="imageContent">
          <div className="imageContent-title">
            <div className="imageContent-title-h1">联系我们</div>
            <div className="imageContent-title-text">CONTACT US</div>
          </div>
        </div>
        <div className="relation-Content">
          <div className="relation-Content-item" style={{ marginRight: '.8rem' }}>
            <div className="relation-Content-item-title" style={{ textAlign: 'center' }}>
              北京锐控自动化科技有限公司
            </div>
            <div className="relation-Content-item-text">
              <div className="relation-Content-item-details">
                <div className="relation-Content-item-details-title">
                  <img src={require('../image/dianhua-icon.png')} className="relation-Content-item-details-img"></img>
                  <span>联系电话</span>
                </div>
                <div className="relation-Content-item-details-content">
                  <div className="relation-Content-item-details-content-item">林经理 155 3550 0634</div>
                  <div className="relation-Content-item-details-content-item">何经理 137 1622 9000</div>
                  <div className="relation-Content-item-details-content-item">师经理 185 1309 9902</div>
                </div>
              </div>
              <div className="relation-Content-item-details">
                <div className="relation-Content-item-details-title">
                  <img src={require('../image/dianhua-icon.png')} className="relation-Content-item-details-img"></img>
                  <span>联系电话</span>
                </div>
                <div className="relation-Content-item-details-content">
                  <div className="relation-Content-item-details-content-item" style={{ width: '13.714286rem' }}>
                    北京市大兴区黄亦路格雷众创园B座527
                  </div>
                </div>
              </div>
              <div className="relation-Content-item-details">
                <div className="relation-Content-item-details-title">
                  <img src={require('../image/dianhua-icon.png')} className="relation-Content-item-details-img"></img>
                  <span>联系电话</span>
                </div>
                <div className="relation-Content-item-details-content">
                  <div className="relation-Content-item-details-content-item">linlijun2004@126.com</div>
                  <div className="relation-Content-item-details-content-item">zhao_ming5@foxmail.com</div>
                </div>
              </div>
            </div>
          </div>
          <div className="relation-Content-item">
            <div className="relation-Content-item-title">在线留言</div>
            <div className="relation-Content-item-text" style={{ paddingRight: '1.457143rem', paddingLeft: '1.371429rem' }}>
              <input className="relation-Content-item-input" placeholder="您的姓名"></input>
              <input className="relation-Content-item-input" placeholder="请输入您的电话"></input>
              <input className="relation-Content-item-input" placeholder="请输入您的邮箱"></input>
              <textarea className="relation-Content-item-textarea" placeholder="请留言"></textarea>
              <div className="relation-Content-item-button">提交</div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <iframe src="https://www.amap.com/place/B0H6LDFHME" className="myiframe"></iframe>
        </div>

        <Footer />
      </div>
    )
  }
}
